import React from 'react'
import INICIO from '../../assets/img/INICIO.PNG'
const Inicio = () => {
    return (
      <div className='principal'>
      <img src={INICIO}  />
    </div>
    )
}

export default Inicio
